import { render, staticRenderFns } from "./Formation.vue?vue&type=template&id=21ca3310&"
import script from "./Formation.vue?vue&type=script&lang=js&"
export * from "./Formation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports